import { Form } from '@dev/ee-api/ee-api-models';
import { getPublishScript } from '../../tools/getPublishScript';

export const getEmbeddedForm = (formObject: Form): string => {
    if (!formObject?.PublicFormID || !formObject?.Link) {
        return '';
    }
    
    const [,lid] = formObject?.Link?.split('lid=') ?? ['',''];
    return getPublishScript(lid);
}
